module.exports = __webpack_public_path__ + "img/trash.4c21a75e.svg";